(function(){
var P=window.COLO_P;if(!P)return;
function $(s,r){return (r||document).querySelector(s)}
function money(c){return '$'+(c/100).toFixed(2)}
function curId(){var i=$('form[action*="/cart/add"] input[name=id]');return i&&P.v[i.value]?i.value:Object.keys(P.v)[0]}
var KEY='colo_rv';
function load(){try{return JSON.parse(localStorage.getItem(KEY))||[]}catch(e){return[]}}
var prev=load(),others=prev.filter(function(h){return h!==P.handle});
try{localStorage.setItem(KEY,JSON.stringify([P.handle].concat(others).slice(0,12)))}catch(e){}
function stock(){
  var v=P.v[curId()],el=$('.colo-lowstock'),n=v&&v[2]?v[1]:0;
  if(v&&n>0&&n<=3){
    if(!el){el=document.createElement('div');el.className='colo-lowstock';var f=$('product-form');if(f&&f.parentNode)f.parentNode.insertBefore(el,f);else return}
    el.innerHTML='<span class="colo-lowstock__dot"></span>Only '+n+' left in stock — order soon';
  }else if(el)el.remove();
}
var io;
function bar(){
  if(!matchMedia('(max-width:749px)').matches)return;
  var btn=$('.product-form__submit');if(!btn)return;
  var b=$('.colo-sticky');
  if(!b){
    b=document.createElement('div');b.className='colo-sticky';
    b.innerHTML='<img alt=""><div class="colo-sticky__i"><div class="colo-sticky__t"></div><div class="colo-sticky__p"></div></div><button type="button" class="colo-sticky__b">Add to cart</button>';
    if(P.img)b.querySelector('img').src=P.img;
    b.querySelector('.colo-sticky__t').textContent=P.title;
    b.querySelector('button').addEventListener('click',function(){var s=$('.product-form__submit');if(s&&!s.disabled)s.click()});
    document.body.appendChild(b);document.body.classList.add('template-product');
  }
  var v=P.v[curId()];if(v)b.querySelector('.colo-sticky__p').textContent=money(v[0]);
  var sb=b.querySelector('button');sb.disabled=!!btn.disabled;sb.textContent=btn.disabled?'Sold out':'Add to cart';
  if(io)io.disconnect();
  io=new IntersectionObserver(function(e){var r=e[0];b.classList.toggle('is-on',!r.isIntersecting&&r.boundingClientRect.top<0)});
  io.observe(btn);
}
async function rv(){
  if(!others.length||$('.colo-rv'))return;
  var res={};
  await Promise.all(others.slice(0,8).map(async function(h){try{var p=await (await fetch('/products/'+h+'.js')).json();if(p.available)res[h]=p}catch(e){}}));
  var list=others.slice(0,8).filter(function(h){return res[h]}).map(function(h){return res[h]});
  if(!list.length)return;
  var w=document.createElement('div');w.className='colo-rv page-width colo-upsell';
  var h=document.createElement('div');h.className='colo-upsell__head';var t=document.createElement('h2');t.className='colo-upsell__title';t.textContent='Recently viewed';h.appendChild(t);w.appendChild(h);
  var tr=document.createElement('div');tr.className='colo-upsell__track';
  list.forEach(function(p){
    var a=document.createElement('div');a.className='colo-up';
    var ia=document.createElement('a');ia.className='colo-up__img';ia.href=p.url;
    if(p.featured_image){var im=document.createElement('img');im.src=p.featured_image.replace(/(\.[a-z]+)(\?|$)/i,'_300x300$1$2');im.loading='lazy';im.alt='';ia.appendChild(im)}
    var ta=document.createElement('a');ta.className='colo-up__t';ta.href=p.url;ta.textContent=p.title;
    var pr=document.createElement('div');pr.className='colo-up__p';pr.textContent=money(p.price);
    a.appendChild(ia);a.appendChild(ta);a.appendChild(pr);tr.appendChild(a);
  });
  w.appendChild(tr);var m=$('main');if(m)m.appendChild(w);
}
var tm;function upd(){clearTimeout(tm);tm=setTimeout(function(){stock();bar()},250)}
document.addEventListener('DOMContentLoaded',function(){
  stock();bar();rv();
  new MutationObserver(function(m){
    for(var i=0;i<m.length;i++){var t=m[i].target;if(t.closest&&t.closest('.colo-sticky,.colo-lowstock,.colo-rv'))continue;
      var ch=[].slice.call(m[i].addedNodes).concat([].slice.call(m[i].removedNodes));
      if(ch.length&&ch.every(function(n){return n.nodeType!==1||/colo-/.test(n.className||'')}))continue;upd();return}
  }).observe(document.body,{childList:true,subtree:true});
  document.addEventListener('change',upd);window.addEventListener('resize',upd);
});
})();
